'use strict';

const ironmanCategories = [
  {
    name: '18-24',
    boundary: {
      min: 18,
      max: 24,
    },
  },
  {
    name: '25-29',
    boundary: {
      min: 25,
      max: 29,
    },
  },
  {
    name: '30-34',
    boundary: {
      min: 30,
      max: 34,
    },
  },
  {
    name: '35-39',
    boundary: {
      min: 35,
      max: 39,
    },
  },
  {
    name: '40-44',
    boundary: {
      min: 40,
      max: 44,
    },
  },
  {
    name: '45-49',
    boundary: {
      min: 45,
      max: 49,
    },
  },
  {
    name: '50-54',
    boundary: {
      min: 50,
      max: 54,
    },
  },
  {
    name: '55-59',
    boundary: {
      min: 55,
      max: 59,
    },
  },
  {
    name: '60-64',
    boundary: {
      min: 60,
      max: 64,
    },
  },
  {
    name: '65-69',
    boundary: {
      min: 65,
      max: 69,
    },
  },
  {
    name: '70-74',
    boundary: {
      min: 70,
      max: 74,
    },
  },
  {
    name: '75-79',
    boundary: {
      min: 75,
      max: 79,
    },
  },
  {
    name: '80+',
    boundary: {
      min: 80,
      max: Number.MAX_SAFE_INTEGER,
    },
  },
];

module.exports = ironmanCategories;
